import rdiff from 'recursive-diff'
import { Organization } from '../entities'

/**
 * Takes an old and new state of a organization object and replaces old values with new values
 * @param currentOrganization
 * @param latestOrganization
 * @returns Organization
 */
export function updateOrganization(
    currentOrganization: Organization,
    latestOrganization: Organization
): Organization {
    if (currentOrganization.id !== latestOrganization.id) {
        return currentOrganization
    }

    const diff: rdiff.rdiffResult[] = rdiff.getDiff(
        currentOrganization,
        latestOrganization
    )
    const updatedOrganization: Organization = rdiff.applyDiff(
        currentOrganization,
        diff
    )

    return updatedOrganization
}
